module.exports = {
  src: __webpack_public_path__ + "logo-vsv-ch-b91e8560bd973ccc97c43ca37b5405f9.png",
  width: 74,
  height: 74,
  bytes: 12182,
  type: "png",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-vsv-ch-b91e8560bd973ccc97c43ca37b5405f9.png";
};